import React, { useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
  Step,
  StepLabel,
  Stepper,
  LinearProgress,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../components/MaterialTypography";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import MaterialBox from "../../components/MaterialBox";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import { useState } from "react";
import MaterialButton from "../../components/MaterialButton";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import PolicyForm from "./policyform";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserDetails } from "../../context/auth";
import Swal from "sweetalert2";
import { useLoading } from "../../context/loading";

const AddPolicy = () => {
  const navigate = useNavigate();
  const {
    policycomponent,
    setTogglePage,
    togglePage,
    AccessData,
    user
  } = useUserDetails();
  
  const location = useLocation();
  let userid=user.id
  const { circleLoading, setCirleLoading } = useLoading();
  const [editdisplay, seteditdisplay] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [activeStep, setActiveStep] = useState(0); //Used to store current step
  const steps = ["Personal info", "Employee info", "Bank Details"]; // Used to store getSteps functionality in a variable

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [componentData, setComponentData] = useState({
    policyName: "",
    policyNameStatus: "unchecked",
    version: "",
    versionStatus: "unchecked",
    date: "",
    dateStatus: "unchecked",
    fileupload: null,
  });



  const [id, setId] = useState(null);
  const data = location.state?.data;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
   
    if (id) {
    setId(id);
        console.log("data",data)
        
  setComponentData({
    ...componentData,
    policyName:data.policyName,
    policyNameStatus: "success",
    version:data.version,
    versionStatus: "success",
    date:data.expireDate,
    dateStatus: "success",
    fileupload:data.policyFile?.split('/').pop()
  })
    
    setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const [originalComponentData, setOriginalComponentData] = useState(null);

  const handleComponentDataChange = (event, selectEvent) => {
    let employeeState = { ...componentData };

    // Handle dropdown/select change
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "componentType") {
        const lengthRegex = /^[A-Za-z0-9 ]+$/;
        if (lengthRegex.test(event?.label)) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      employeeState[selectEvent.name] = event;
    }

    // Handle boolean-type inputs
    else if (typeof selectEvent === "boolean") {
      employeeState[event.target.name] = selectEvent;
    }

    // Handle text/date/file input change
    else {
      const { name, value } = event.target;

      switch (name) {
        case "policyName":
          {
            // Validation: max 20 characters, alphabets only
            const alphaRegex = /^([a-zA-Z\s]{1,20})$/;
            if (alphaRegex.test(value.trim())) {
              employeeState[name + "Status"] = "success";
            } else {
              employeeState[name + "Status"] =
                value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "version": {
          const versionRegex = /^[a-zA-Z0-9.]{1,20}$/;

          if (versionRegex.test(value.trim())) {
            employeeState[name + "Status"] = "success";
          } else {
            employeeState[name + "Status"] =
              value === "" ? "unchecked" : "error";
          }
          break;
        }

        case "date":
          {
            // No strict validation, optional field
            employeeState[name + "Status"] =
              value === "" ? "unchecked" : "success";
          }
          break;

        default:
          break;
      }

      employeeState[name] = value;
    }

    setComponentData(employeeState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      componentData.policyNameStatus === "success" &&
      componentData.versionStatus === "success" &&
      componentData.fileupload != null 
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };
  const isFormValid =
    componentData.componentNameStatus === "success" &&
    componentData.abbreviationStatus === "success" &&
    componentData.componentTypeStatus === "success";

  const handleAddComponent = () => {
    if (checkAllFields()) {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          onComponentSubmit();
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  // Function to move the next step
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  // Function to move the previous step
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };



 const onComponentSubmit = async () => {
  setCirleLoading(true);


  const operations = JSON.stringify({
    query: `
      mutation CreatePolicy($input: PolicyInput!) {
        createPolicy(input: $input) {
          success
          message
          policy {
            id
            policyName
          }
        }
      }
    `,
    variables: {
      input: {
        policyName: componentData.policyName,
        version:componentData.version,
        expireDate:componentData.date,
        createdById:userid,
        policyFile: null,
        // IsActive:true,
      }
    }
  });


  const map = JSON.stringify({
    "0": ["variables.input.policyFile"]
  });

  const formData = new FormData();
  formData.append("operations", operations);
  formData.append("map", map);

  const file = componentData.fileupload;
  if (file) {
    formData.append("0", file);
  }

  try {
    const response = await axios.post(BASEURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    if (response.data.data?.createPolicy?.success) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Policy Created successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/policy");
    }

    setConfirmationDialog({ ...confirmationDialog, open: false });
    setCirleLoading(false);
  } catch (error) {
    console.error("Create Error:", error);
    setCirleLoading(false);
    setConfirmationDialog({
      open: true,
      title: "Error message",
      message: "Sorry, something went wrong. Please try again later.",
      showCancel: true,
      showConfirm: false,
      onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
    });
  }
};

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteComponentSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteComponentSubmit = async () => {
    setCirleLoading(true);
    const query = `
    mutation($policyId: ID!, $userId: ID!) {
  deletePolicy(policyId: $policyId, userId: $userId) {
    success
    error
    message

  }
}
    `;
    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          "policyId":id,
          "userId": userid
         },
      });

      if (response.data.data.deletePolicy.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Policy Deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/policy");
        setCirleLoading(false);
      } else {
        console.log(
          "Error deleting policy:",
          response.data.data.deleteDesignation.message
        );
        setCirleLoading(false);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message:
            "Sorry for your inconvience, there is some issue in our network. Please try again later.",
          showCancel: true,
          showConfirm: false,

          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    } catch (error) {
      console.error("An error occurred while deleting the policy:", error);
      setCirleLoading(false);
    }
  };


    
const Oneditcomponent = async () => {
  setCirleLoading(true);
  
  const includeFile = typeof componentData.fileupload === "string";
  const input = {
    policyName: componentData.policyName,
    version: componentData.version,
    expireDate: componentData.expireDate,
    createdById: userid,
    ...(!includeFile && { policyFile: null }) // Only include policyFile if it's not a string
  };

  const operations = JSON.stringify({
    query: `
      mutation UpdatePolicy($policyId: ID!, $input: PolicyInput!) {
        updatePolicy(policyId: $policyId, input: $input) {
          success
          message
          policy {
            id
            policyName
            version
          }
        }
      }
    `,
    variables: {
      policyId: id,
      input
    }
  });

  const formData = new FormData();
  formData.append("operations", operations);

  if (includeFile==false) {
    const map = JSON.stringify({
      "0": ["variables.input.policyFile"]
    });
    formData.append("map", map);

    const file = componentData.fileupload;
    if (file) {
      formData.append("0", file);
    }
  }

  try {
    const response = await axios.post(BASEURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    if (response.data.data?.updatePolicy?.success) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Policy Updated successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/policy");
    }

    setCirleLoading(false);
  } catch (error) {
    console.error("Update Error:", error);
    setCirleLoading(false);
    setConfirmationDialog({
      open: true,
      title: "Error message",
      message: "Sorry, something went wrong. Please try again later.",
      showCancel: true,
      showConfirm: false,
      onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
    });
  }
};


  const onDiscardDesignation = () => {
    if (originalComponentData) {
      setComponentData(originalComponentData); // Reset to original data
    }
    seteditdisplay(false);
    setTogglePage({
      view: true,
      edit: false,
    });
  };

  const handleedit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    seteditdisplay(true);
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/policy");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      {pageState.state === "init" ? (
        <Card>
          <MaterialBox
          // sx={{
          //   display: "flex",
          //   flexDirection: "column",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   textAlign: "center",
          //   // height: "74vh",
          //   margin: "auto",
          // }}
          >
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
              padding={10}
            >
              <Grid size={{ xs: 6, sm: 6 }}>
                <MaterialTypography variant="body2" mb={3}>
                  Please wait while we fetch the Component details for you. This
                  may take a few seconds.
                </MaterialTypography>
                <MaterialBox
                  style={{
                    overflow: "hidden",
                    borderRadius: 5,
                    height: 24,
                  }}
                >
                  <LinearProgress
                    size="lg"
                    color="dark"
                    thickness={16}
                    style={{
                      borderRadius: 5,
                      height: 16,
                      maxHeight: 16,
                    }}
                    sx={{
                      "& .MuiLinearProgress-bar": {
                        height: 16,
                      },
                    }}
                  />
                </MaterialBox>
              </Grid>
            </Grid>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Policy Details
                  </MaterialTypography>
                </Stack>

                {AccessData &&
                  Array.isArray(AccessData) &&
                  // AccessData.some(
                  //   (item) =>
                  //     item.component === "EditComponent" && item.can_access
                  // ) &&
                  AccessData.some(item =>item.module=="Policy"&& item.component === 'EditPolicy' && item.can_access)&&
                  policycomponent && (
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Loading button group"
                    >
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleedit}
                        startIcon={<EditIcon />}
                      >
                        Edit
                      </MaterialButton>

                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={AddDelete}
                        startIcon={<DeleteIcon />}
                      >
                        Delete
                      </MaterialButton>
                    </ButtonGroup>
                 )} 
              </Stack>
            }
          />
          <CardContent sx={{ minHeight: "60vh" }}>
            <MaterialBox>
              <PolicyForm
                componentData={componentData}
                togglePage={togglePage}
                handleComponentDataChange={handleComponentDataChange}
              />
            </MaterialBox>
          </CardContent>
          <CardActions></CardActions>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {!policycomponent && (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handlecancel}
                >
                  Cancel
                </MaterialButton>
              {AccessData && Array.isArray(AccessData) && AccessData.some(item =>item.module=="Policy"&& item.component === 'SavePolicy' && item.can_access)&& (  
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  sx={{ m: 2, marginLeft: "4px" }}
                  disabled={!checkAllFields()}
                  onClick={handleAddComponent}
                >
                  Submit
                </MaterialButton>
                )} 
              </>
            )}
          </MaterialBox>

          <CardActions>
            <MaterialBox
              p={3}
              mt={3}
              width="100%"
              display="flex"
              justifyContent="end"
            >
              {editdisplay && (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={onDiscardDesignation}
                  >
                    Discard
                  </MaterialButton>
                {AccessData && Array.isArray(AccessData) && AccessData.some(item =>item.module=="Policy"&& item.component === 'UpdatePolicy' && item.can_access)&& ( 
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    style={{
                      maxWidth: "115px",
                      minWidth: "120px",
                      marginLeft: "2%",
                    }}
                    disabled={!checkAllFields()}
                    onClick={Oneditcomponent}
                  >
                    Update
                  </MaterialButton>
                    )} 
                </>
              )}
            </MaterialBox>
          </CardActions>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddPolicy;
